"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSchemaType = void 0;
require("../0.0.2");
require("./text-schema");
var universal_schema_types_enum_1 = require("./universal_schema_types_enum");
Object.defineProperty(exports, "UniversalSchemaType", { enumerable: true, get: function () { return universal_schema_types_enum_1.UniversalSchemaType; } });
